// apps/admin-ui/src/components/sidebars/LoyaltySidebar.tsx
import { NavLink, useParams } from 'react-router-dom';
import {
  Activity, Award, Crosshair, Calendar, Flame,
  Users, TrendingUp, Ticket, Trophy,
  Star, Gift, Zap, Tag, Settings,
  type LucideIcon,
} from 'lucide-react';
import { ProgramSwitcher } from '../loyalty/ProgramSwitcher.tsx';
import { sidebarItemClass, sidebarSectionLabelClass } from './sidebarStyles.ts';

interface SectionDef {
  label: string;
  items: { section: string; label: string; icon: LucideIcon }[];
}

const SECTIONS: SectionDef[] = [
  {
    label: '',
    items: [{ section: 'overview', label: 'Overview', icon: Activity }],
  },
  {
    label: 'Engagement',
    items: [
      { section: 'badges',        label: 'Badges',       icon: Award },
      { section: 'missions',      label: 'Missions',     icon: Crosshair },
      { section: 'contests',      label: 'Contests',     icon: Calendar },
      { section: 'flash-rewards', label: 'Flash Rewards', icon: Flame },
    ],
  },
  {
    label: 'Operations',
    items: [
      { section: 'members',     label: 'Members',     icon: Users },
      { section: 'ledger',      label: 'Ledger',      icon: TrendingUp },
      { section: 'coupons',     label: 'Coupons',     icon: Ticket },
      { section: 'leaderboard', label: 'Leaderboard', icon: Trophy },
    ],
  },
  {
    label: 'Configuration',
    items: [
      { section: 'tiers',       label: 'Tiers',       icon: Star },
      { section: 'rewards',     label: 'Rewards',     icon: Gift },
      { section: 'point-rules', label: 'Point Rules', icon: Zap },
      { section: 'interests',   label: 'Interests',   icon: Tag },
    ],
  },
];

export function LoyaltySidebar() {
  const { id } = useParams<{ id: string }>();

  if (!id) return null;

  return (
    <nav className="flex flex-col py-2 gap-0">
      <ProgramSwitcher />

      {SECTIONS.map((sec) => (
        <div key={sec.label || '__top'}>
          {sec.label && (
            <span className={sidebarSectionLabelClass}>{sec.label}</span>
          )}
          <div className="px-2 flex flex-col gap-0.5">
            {sec.items.map(({ section, label, icon: Icon }) => (
              <NavLink
                key={section}
                to={`/loyalty/${id}/${section}`}
                className={({ isActive }) => sidebarItemClass(isActive)}
              >
                <Icon size={14} className="shrink-0" />
                {label}
              </NavLink>
            ))}
          </div>
        </div>
      ))}

      <div className="mt-auto pt-2 mx-2 border-t border-zinc-100">
        <NavLink
          to={`/loyalty/${id}/settings`}
          className={({ isActive }) => sidebarItemClass(isActive)}
        >
          <Settings size={14} className="shrink-0" /> Settings
        </NavLink>
      </div>
    </nav>
  );
}
